import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { AppExeDLInfo } from '../../_objects/distributes';
import { DistributionManagementContractService } from '../interfaces/distribution-management-contract.service';

@Injectable({
  providedIn: 'root'
})
export class DistributionManagementOfflineService implements DistributionManagementContractService {

  constructor() { }
  getAppExe(version: string): Observable<AppExeDLInfo> {
    return of();
  }
}
